import { router } from '../../app';
import { store } from '../'


const state = () => ({
    moduleNavItems: [],
    notifications: [],
    utilities: [],
    breadCrumbs: [],
    activeToasts: [],
    pendingNotifications: []
});

const getters = {
    //cards: state => state.cards,
    notifications: state => state.notifications,
    moduleNavItems: state => state.moduleNavItems,
    utilities: state => state.utilities,
    breadCrumbs: state => state.breadCrumbs,
    activeToasts: state => state.activeToasts,
    pendingNotifications: state => state.pendingNotifications
};

const mutations = {
    setModuleNavs(state, payload){
        state.moduleNavItems = payload;
    },
    setUtilities(state, payload){
        state.utilities = payload;
    },
    setBreadcrumbs(state, payload){
        state.breadCrumbs = payload;
    },
    updateBreadcrumbs(state, payload){
        state.breadCrumbs.push(payload);
    },
    removeBreadcrumbs(state, index){
        let buffer = [];
        for(let i=0; i <= index; i++){
            buffer.push(state.breadCrumbs[i]);
        };
        state.breadCrumbs = buffer;
    },
    pushPendingNotification(state, notification){
        state.pendingNotifications.push({
            ...notification,
            id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
            timeStamp: Date.now()
        });
    },
    pushNotification(state, notification){
        state.notifications.push({
            ...notification,
            id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
            timeStamp: Date.now()
        });
    },
    pushToast(state, notification){
        state.activeToasts.push(notification);//{
        //    ...notification,
       //     id: (Math.random().toString(36) + Date.now().toString(36)).substr(2)
       // });
    },
    removeToast(state, toastToRemove){
        state.activeToasts  = state.activeToasts.filter(toast => {
            return toast.id != toastToRemove.id;
        });
    },
    removeNotification(state, notificationToRemove){
        state.notifications  = state.notifications.filter(notification => {
            return notification.id != notificationToRemove.id;
        });
    },
    removePendingNotification(state, pendingnotificationToRemove){
        state.notifications  = state.notifications.filter(notification => {
            return notification.id != pendingnotificationToRemove.id;
        });
    }
};

const actions = {
    addNotification({commit}, notification){
        notification = {...notification,
            id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
            timeStamp: Date.now()
        };
        //commit('pushPendingNotification', notification)
        commit('pushNotification', notification);
        console.log('notification: ', JSON.stringify(notification))
        store.dispatch('ProductCollection/addNotificationToStorage', notification, { root: true });
        if((notification.status.includes('rror')) ||(notification.status.includes('ailed'))){
            store.dispatch('Navigation/addToast', notification, { root: true } );
        }
        //store.dispatch('ProductCollection/addToast', notification
    },
    addPendingNotification({commit}, notification){
        //console.log("Pending notifiication");
        notification = {...notification,
            id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
            timeStamp: Date.now()
        };
        commit('pushPendingNotification', notification)
        store.dispatch('ProductCollection/addPendingNotificationToStorage', notification, { root: true });
        return notification
        //setTimeout(() => {console.log('pending return'); return notification}, 5000)
    },
    addToast({commit}, notification){
        //console.log('toast - ' + JSON.stringify(notification))
        commit('pushToast', notification);

    },
    removeToast({commit}, toast){
        commit('removeToast', toast);
    },
    removeNotification({commit}, notification){
        commit('removeNotification', notification);
        store.dispatch('ProductCollection/removeNotification', notification.id, { root: true });
    },
    removePendingNotification({commit}, notification){
        commit('removePendingNotification', notification);
        store.dispatch('ProductCollection/removePendingNotification', notification.id, { root: true });
    },
    moduleNavigation({commit}, payload){
        //console.log('setLink'+ payload.type);
        //console.log('setSection'+ payload.name);
        store.dispatch(payload.type+'/changeActiveType', payload.name);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
